import { Injectable } from '@angular/core';

@Injectable()
export class Configuration {
    public Server: string = "http://172.16.6.110:2016/";
    public ApiUrl: string = "api/";
    public ServerWithApiUrl = this.Server + this.ApiUrl;
}


// WEBPACK FOOTER //
// ./src/app/Shared/Constants/app.constants.ts